import React from "react";

const TECH_STACK = {
  0: ["Next.js 14", "React", "TypeScript", "Tailwind CSS", "NextAuth.js", "MongoDB", "Zustand"],
  1: ["Java", "Spring Boot", "Spring MVC", "Hibernate", "React.js", "MySQL", "REST API", "JWT"],
  2: ["Java", "Spring MVC", "Hibernate", "React.js", "MySQL", "OAuth", "REST API", "JWT"],
  3: ["Java", "Spring MVC", "JSP", "Hibernate", "MySQL"],
  4: ["Java", "Spring MVC", "JSP", "Hibernate", "MySQL"],
};

function ProjectCards({ name, image, index, link, about, type }) {
  const formattedIndex = String(index + 1).padStart(2, "0");
  const stack = TECH_STACK[index] || [];

  return (
    <article className='grid grid-cols-1 gap-x-10 gap-y-6 border-b border-line py-12 lg:grid-cols-12 lg:items-start'>
      {/* Index + meta */}
      <div className='flex items-baseline gap-4 lg:col-span-2 lg:flex-col lg:gap-3'>
        <span className='font-heading text-3xl font-bold tabular-nums text-primary/25'>
          {formattedIndex}
        </span>
        <span className='font-body text-2xs font-medium uppercase tracking-widest text-primary/45'>
          {type}
        </span>
      </div>

      {/* Image — flat, grid-cropped */}
      <div className='lg:col-span-5'>
        <div className='relative aspect-[16/10] w-full overflow-hidden border border-line bg-secondary'>
          <img
            src={image}
            alt={name}
            loading='lazy'
            className='h-full w-full object-cover grayscale'
          />
        </div>
      </div>

      {/* Info */}
      <div className='flex flex-col gap-5 lg:col-span-5'>
        <div>
          <h3 className='font-heading text-2xl font-bold leading-tight tracking-tight text-primary md:text-3xl'>
            {name}
          </h3>
          <p className='mt-3 max-w-md font-body text-sm leading-relaxed text-primary/60 md:text-base'>
            {about}
          </p>
        </div>

        {/* Tech stack */}
        <div>
          <h4 className='mb-3 font-body text-2xs font-medium uppercase tracking-widest text-primary/35'>
            Stack
          </h4>
          <div className='flex flex-wrap gap-x-4 gap-y-1.5'>
            {stack.map((tech) => (
              <span
                key={tech}
                className='font-body text-xs text-primary/55'
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        <a
          href={link}
          target='_blank'
          rel='noopener noreferrer'
          className='group mt-1 inline-flex w-fit items-center gap-2 border-b border-primary/25 pb-1 font-body text-xs font-semibold uppercase tracking-wider text-primary transition-colors hover:border-accent hover:text-accent'
        >
          View repository
          <svg
            width='13'
            height='13'
            viewBox='0 0 24 24'
            fill='none'
            aria-hidden='true'
          >
            <path
              d='M7 17L17 7M17 7H7M17 7V17'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </a>
      </div>
    </article>
  );
}

export default ProjectCards;
